package com.macrofocus.eflux

import korlibs.time.*

@Suppress("EnumEntryName")
enum class LagUnit {
    minutes {
        override val unit = 1.minutes
        override val step = 5
        override val max = 24.hours
        override val params = "lag=1d&interval=5m"
    },
    hours {
        override val unit = 1.hours
        override val step = 1
        override val max = 7.days
        override val params = "lag=${24 * 7}h&interval=1h"
    },
    days {
        override val unit = 1.days
        override val step = 1
        override val max = 180.days
        override val params = "lag=180d&interval=1d"
    },
    weeks {
        override val unit = 1.weeks
        override val step = 1
        override val max = 156.weeks
        override val params = "lag=${156 * 7}d&interval=7d"
    };

    abstract val unit: TimeSpan
    abstract val step: Int
    abstract val max: TimeSpan
    abstract val params: String
}